export default "__VITE_ASSET__27c5abf4__"